export enum CouponTypeEnum {
  Fixed = 'fixed',
  Percent = 'percent',
}
